import { render, staticRenderFns } from "./RecursosOperacionaisSplitLayout.vue?vue&type=template&id=1c8623bc&scoped=true&"
import script from "./RecursosOperacionaisSplitLayout.vue?vue&type=script&lang=js&"
export * from "./RecursosOperacionaisSplitLayout.vue?vue&type=script&lang=js&"
import style0 from "./RecursosOperacionaisSplitLayout.vue?vue&type=style&index=0&id=1c8623bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8623bc",
  null
  
)

export default component.exports